// extracted by mini-css-extract-plugin
export default {"container":"Hr-z","heading":"Ir-z","text":"Jr-z","info":"Kr-z","link":"Lr-z","fullMaxWidth":"Mr-z"};